<template>
  <div class="protocol-container">
    <div class="logo-wrap">
      <router-link :to="{ name: 'Home' }">
        <img class="header-img" :src="brandLogo" alt="" />
      </router-link>
    </div>
    <div class="agreement-content">
      <h1>魔果云课用户隐私政策</h1>
      <p style="margin-bottom: 15px">更新日期：2024年06月10日</p>
      <p>生效日期：2024年06月10日</p>
      <p>
        北京闵氏超体网络科技有限公司（以下简称“我们”、“魔果云课”或“魔果”）非常重视每一位用户隐私权和个人信息保护，我们将根据法律法规要求和技术规范，为您提供充分的个人信息安全保障，将保护用户隐私作为一项基本政策。本隐私政策（以下或称“本政策”）仅适用于魔果云课App相关产品及服务。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。本隐私政策将向您说明我们如何收集、使用、保存、共享、披露和转让这些信息。我们、我们关联公司或合作伙伴/机构所有产品和服务均适用本隐私政策（以下或称“本政策”），请您注意本政策不适用于以下情况：（1）通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；（2）通过在我们服务中进行广告服务的其他公司和机构所收集的信息。本政策可能涉及的相关术语，我们会尽量采用通俗易懂的表述方式向您进行说明和告知，以便您可以更好的理解。
      </p>
      <p>
        <b>
          <span class="underline"> 特别提示 </span>
        </b>
      </p>
      <p>
        请您在使用我们提供的任何服务前，仔细阅读并了解本政策的全部条款，特别是与您的权益存在重大关系的条款、我们以粗体/粗体下划线/粗体标红提示您注意的条款（包括但不限于减轻、免除或限制责任的条款、法律适用及管辖条款）。本政策将向您说明我们如何收集、使用、保存、共享和转让这些信息，以及使用您个人信息的目的、范围、方式等内容，我们强烈建议您能仔细阅读、充分理解本政策的全部内容，并作出您认为的适当的选择。如果您不同意本政策任何内容，您应立即停止使用我们的产品或服务。当您使用或继续使用我们提供的任一服务时，即表示您已充分阅读、理解并同意我们按照本政策来收集、使用、存储和保护您的相关信息，本政策对您及我们均具有法律约束力。
      </p>
      <p>
        请您审慎阅读并选择接受或不接受本政策，当您按照注册页面上的提示同意接受本政策的全部内容，且在注册程序过程中点击“同意”按钮，完成全部的注册程序后,视为您接受本政策全部内容，并与魔果达成一致，本政策生效后对您及魔果均具有法律约束力。如果您不同意本政策的内容，您应立即停止注册程序。如本政策有任何变更，我们将变更后的政策公布于魔果云课官网、App客户端和小程序中，并以系统内消息方式通知您。如您不同意相关变更，应立即停止使用服务。如在变更后的政策公布后，您继续使用服务则表示您已接受了变更后的政策。
      </p>
      <p>
        如您为未成年人，请务必在法定监护人陪同下审慎阅读本政策，您使用服务的行为视为您已获得了法定监护人的认可；如您为14周岁以下儿童，请务必先在法定监护人的陪同下审慎阅读我们的《儿童个人信息保护政策》，在确保已取得法定监护人的同意后，方可在其指导下使用我们的服务。
      </p>
      <p>
        如您对本政策内容有任何疑问、意见或建议，请通过“第十条如何联系我们”与我们联系。
      </p>
      <p>本政策将帮助您了解以下内容：</p>
      <div class="list-wrap">
        <p>一、我们如何收集、使用您的个人信息</p>
        <p>二、我们如何使用Cookie、Beacon、SDK等同类技术</p>
        <p>三、我们如何共享、转让、披露您的个人信息</p>
        <p>四、我们如何存储和保护您的个人信息</p>
        <p>五、您如何保护和管理您的个人信息</p>
        <p>六、本政策的适用和修订</p>
        <p>七、关于未成年人信息的保护</p>
        <p>八、术语释义</p>
        <p>九、法律适用与管辖</p>
        <p>十、如何联系我们</p>
      </div>
      <h2>一、我们如何收集、使用您的个人信息</h2>
      <h3>（一）您主动授权的信息</h3>
      <p>
        在您使用我们的产品与/或服务时，您理解并同意，我们将根据下列不同场景下的相应目的收集、使用您特定种类的个人信息，用以向您提供服务、提升我们的服务质量、保障产品或服务的安全、合规。若您不提供这类信息，您依然可以正常使用我们的相关服务，但部分附加功能可能无法使用。例如：
      </p>
      <div class="list-wrap">
        <p>
          1）基于录音的附加功能。您授权我们启用您的录音功能，您可在课程交流区发布语音消息，在作业区提交语音形式的作业，在讨论区发布语音形式的评论等。
        </p>
        <p>
          2）基于照片和媒体资料库的附加功能。您授权我们访问您的本地相册和媒体资料库，您可以选择本地的照片，用于更新您的账号头像，在课程交流区发布图片消息，在作业区上传图片形式的作业，在讨论区发布图片形式的评论等。
        </p>
        <p>
          3）基于拍摄照片和录制视频的附加功能。您授权我们启动您的照片拍摄及视频录制功能，可方便您在手机端发起直播等。
        </p>
        <p>
          4）基于日历的附加功能（仅限于IOS端APP）。您授权我们访问您的日历，您可以将直播课的上课提醒等学习提醒加入到您的日历中，以便您制定良好的学习计划。
        </p>
        <p>
          5）基于悬浮窗的附加功能。您授权我们启用悬浮窗功能，在您离开直播间时，直播内容将以悬浮小窗口的方式呈现在产品界面上，方便您随时观看。
        </p>
        <p>
          6）基于电话状态的附加功能。您授权我们获取您的设备信息（包括在后台状态下收集）时访问您的电话权限，以更好的为您提供每次打开安卓端APP看直播时的服务（启动声网音视频直播引擎需要获取设备信息）。另您授权我们拨打电话和管理通话权限（仅限于IOS端APP），您可在产品相关页面中直接拨打客服电话等。
        </p>
        <p>
          7）基于剪切板的附加功能。您授权在每次打开APP时允许我们调用剪切板（如兑换码功能：为了让用户使用兑换码，APP会读取剪贴板以识别用户的兑换码并引导其加入课程），便于我们可以根据您剪切板中特定格式的内容，由系统识别后，将您添加到对应页面中。为切实保障您的隐私安全，我们仅读取剪切板中出现的可由系统识别特定格式的内容，不读取其他内容，且读取的内容不存储在客户端本地（不留存历史记录），以及不上传至我们服务器。
        </p>
      </div>
      <p>
        您理解并同意，上述附加功能可能需要您在您的设备中开启您的麦克风（录音）、相册（本地相册和媒体资料库）、摄像头（照片拍摄及视频录制）、日历、悬浮窗、设备传感器、电话状态及/或剪切板的访问权限，以实现这些权限所涉及信息的收集和使用。请您知晓并理解，上述设备传感器信息不涉及任何个人位置信息且无法与其他信息结合用于识别特定自然人身份。
      </p>
      <p>
        上述附加功能可能需要您在您的设备中向我们的应用程序开启相应的访问权限。（若您的设备/操作系统支持您随时可以自主地决定是否开启或关闭上述附加功能）。请您注意，一旦您开启了相关权限或提交了相关信息，即视为您已主动向我们授权收集和使用上述信息。如果您关闭了相关权限，即代表您取消了这些授权，我们将不再继续收集使用您的这些个人信息。您关闭权限的决定不会影响此前基于您的授权我们所进行的个人信息的处理。
      </p>
      <p>
        另，我们为确保我们的产品与/或服务处于关闭或者后台运行状态下可以正常接收消息，我们须使用（自启动）能力通过系统发送广播唤醒APP应用自启动或关联启动，这是因实现功能及服务所必要的。如您不想开通此功能，我们建议您手动进行关闭，一般关闭路径：设置-应用-应用启动管理-选择应用“魔果云课”-关闭关联启动功能。
      </p>
      <h3>（二）我们向您提供产品与/或服务时所必需收集的信息</h3>
      <p>
        在您使用我们的产品与/或服务时，应产品或服务的功能本身、改进产品或服务的功能以及保障产品或服务的安全、合规，我们可能会收集、使用和保存下列与您有关的信息来实现前述功能的安全、合规。如果您不提供相关信息，您将无法享受我们的产品与/或服务。这些功能主要包括：
      </p>
      <p>
        <b> 1)用户注册与登录</b>
      </p>
      <p>
        您在使用我们提供的绝大部分产品与/或服务前，需要先注册成为我们的用户。在您注册成为我们的用户时，您需要至少向我们提供您的昵称、密码、您本人的手机号码、您的邮箱地址，我们将通过发送短信验证码或邮件验证的方式验证您的身份是否有效。
      </p>
      <p>
        您在移动设备上登录和使用我们的产品与/或服务前，我们需要申请获取设备信息（包括在后台状态下收集），主要包括硬件型号、硬件设备参数、操作系统类型和基本信息、Mac地址、移动设备标识码（IMSI、IMEI、AndroidID、ICCID、设备SN、IDFA、IDFV、OAID、MEID）、设备序列号和设备名，设备信息将关联到您登陆的账号，这将方便您查看和管理常用的登录设备，规避账号丢失风险，确保账号使用安全；同时借助IMEI、IDFA、IDFV、OAID、MEID、ICCID、设备SN、AndroidID移动设备标识别码，我们可以向您推送重要的学习通知，包括开直播课上课提醒、活动提醒等。除此之外，我们还需要申请设备SD卡的读写权限，以便在设备上存储应用正常使用产生的本地数据、依赖的配置文件、缓存的课程视频文件等。
      </p>
      <p>
        您需理解，手机号码或电子邮箱地址和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是基于法律法规的相关要求，如您拒绝提供可能导致您无法注册账号并使用相关产品功能，请您谨慎考虑后再选择是否提供。
      </p>
      <p>
        同时，当我们支持更方便快捷的共享登录方式时，在您使用这些第三方授权登录方式时，我们将收集您的包含但不限于头像、昵称、地区、性别信息、邮箱、手机号码等；；收集前，将通过上述第三方的授权功能获得您的授权。
      </p>
      <p>
        <b> 2)信息检索 </b>
      </p>
      <p>
        您为了快速检索一些信息，例如课程信息、文章信息等，我们可能会收集您输入的查询关键词和个人设备信息以优化我们向您提供的服务体验。
      </p>
      <p>
        <b> 3)购买支付</b>
      </p>
      <p>
        当您准备购买我们提供的商品或服务时，或您准备购买由我们的关联公司、合作伙伴/机构提供的商品或服务时，我们的系统会生成您的购买订单。此过程可能会要求您填写收货人姓名、收货地址、联系方式（个人敏感信息），同时订单中会载明您的订单号、购买的商品或服务信息、应当支付的金额和支付方式，支付功能本身并不收集您的个人信息，但我们需要将您的订单信息及对账信息与这些支付机构共享以确认您的支付指令并完成支付。
      </p>
      <p>
        上述信息构成您的订单信息，我们收集订单信息是为了帮助您顺利完成交易，我们会使用您的订单信息来进行身份核验、确定交易、支付结算、配送、咨询售后，我们还会使用订单信息来判断您的交易是否存在异常以保护您的交易安全。
      </p>
      <p>
        <b> 4)课程学习 </b>
      </p>
      <p>
        您使用我们或我们的关联公司、合作伙伴/机构提供的课程、辅导、学习服务时，我们可能会记录您的学习信息，主要包括：您的学习行为数据、测验结果、做题结果、学习时长、课堂交流内容、学习偏好等。我们将应用这部分信息分析您的学习状态，为您或为我们的服务提供优化参考依据。
      </p>
      <p><b>5）直播服务 </b></p>
      <p>
        当您观看手机直播或使用手机进行直播时，我们可能会进行系统声道模式切换，以便为您提供更好的视听体验。
      </p>
      <p><b>6）客服售后 </b></p>
      <p>
        平台上合作的分享者的客服人员、课程顾问或我们合作的第三方机构会通过您账号预留的手机号码或其他通讯方式与您取得联系。我们可能会保存您的通信或通话记录和内容或您留下的联系方式，以便帮助您解决问题，或记录相关问题的处理方案及结果。
      </p>
      <p>
        我们的客服会使用您的帐号信息与您核验身份，可能需要您在与我们的客服人员沟通时，提供给出上述信息外的其他信息。我们收集这些信息、课程顾问或我们合作的第三方机构会通过您账号预留的手机号码或其他通讯方式与您取得联系。我们可能会保存您的通信或通话记录和内容或您留下的联系方式，以便帮助您解决问题，或记录相关问题的处理方案及结果。
      </p>
      <p>
        我们的客服会使用您的帐号信息与您核验身份是为了帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。
      </p>
      <p><b>7)服务改进 </b></p>
      <p>
        我们可能会收集您的个人信息进行数据分析用以为您提供个性化定制的服务，或用其为我们的服务进行未来的改进和调整。随着我们产品的后续版本升级，我们统计的范围会有所改变，您下载/安装/使用我们后续版本产品的行为将被视为您对届时相关改变的同意。我们访问您的广告追踪权限，是为了统计广告的浏览和点击数据，以便为您提供更合适的展示页面。
      </p>
      <p><b> 8)实名绑卡 </b></p>
      <p>
        如果您开通了我们的资金账户或其他必须经过实名方能提供服务的功能与/或产品，则我们会要求您完成实名认证或绑定银行卡。在实名认证或绑定银行卡的过程中，您需要向我们至少提供您的真实姓名、有效证件号码、银行卡号码、银行预留手机号，并通过向银行预留手机号下发动态验证码的方式验证您的实名信息。如果必要，我们还会继续采集您的身份证复印/扫描件或/和手持身份证照片、真人面部信息、真人语音信息等实人认证信息。
      </p>
      <p><b>9)安全保障 </b></p>
      <p>
        为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护您的账户安全，我们可能会通过了解您的浏览信息、订单信息、您常用的应用软件信息、设备信息、用户行为信息等手段来判断您的账号风险，并可能会记录一些技术判断为异常的链接地址。我们也会收集您的设备信息（包括在后台状态下收集）用作问题进行分析，统计流量并排查可能存在的风险。
      </p>
      <p><b>10）技术支持 </b></p>
      <p>
        为了保障您正常使用我们的产品功能，在您登录和使用我们的产品与/或服务时，我们会收集设备名称、设备型号、设备分辨率、硬件制作商、网络类型及供应商、操作系统名称、操作系统版本、IP地址、androidid、应用列表等信息，在您遇到应用不兼容、功能报错、程序崩溃等情况时，以上信息将有助于我们的技术团队分析问题、排除故障，为您提供及时有效的技术支持。
      </p>
      <p>
        我们希望提供给您的服务是完善的，所以我们会不断改进我们的服务，包括技术。这意味着我们的服务可能会经常推出新功能，可能需要收集新的信息。如果我们收集使用个人信息的目的、方式和范围发生变化时或调整，我们会通过适当的方式通知您。
      </p>
      <h3>（三）收集、使用信息且无需征得您的同意的情形</h3>
      <p>
        您充分知晓，在以下情形中我们收集、使用个人信息无需征得您的授权和同意：
      </p>
      <div class="list-wrap">
        <p>1）与国家安全、国防安全有关的；</p>
        <p>2）与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>4)有充分证据证明您存在主观恶意或滥用权利的；</p>
        <p>5)响应您的请求将导致其他个人、组织的合法权益受到严重损害的；</p>
        <p>
          6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益，但又很难得到本人同意的；
        </p>
        <p>
          7）所收集的个人信息是个人信息主体、父母或监护人自行向社会公众公开的；
        </p>
        <p>
          8）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>9）根据您的要求签订合同所必需的；</p>
        <p>
          10)用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
        </p>
        <p>
          11)为新闻单位或学术研究机构基于新闻报道、公共利益开展统计或学术研究所必要等，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理，且数据接收方无法复原并重新识别个人信息的；
        </p>
        <p>12)应国家有权机关的要求的；</p>
        <p>13）法律法规规定的其他情形。</p>
      </div>
      <h3>（四）来自于第三方的个人信息</h3>
      <p>
        我们可能从我们的关联公司、合作伙伴/机构、第三方获取您授权共享的个人信息（例如从第三方登录带来您的头像、第三方登录账号、昵称信息），依据本政策使用您的个人信息，并在您同意本政策后将这部分信息与您的账号绑定。我们将会依据与我们的关联公司、合作伙伴/机构、第三方的协议，对个人信息来源的合法性进行确认后，在符合相关法律法规的前提下使用您的这些个人信息。我们会采取必要的技术和管理措施尽可能地保护您的个人信息安全。
      </p>
      <h3>（五）个人信息的匿名化使用</h3>
      <p>
        在收集您的个人信息后，我们将通过技术手段对数据进行匿名化处理，匿名化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经匿名化的信息；并在不透露您个人信息的前提下，我们有权对我们的产品与/或服务使用情况进行统计，并可能会与公众、我们的关联公司或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。
      </p>
      <p>
        请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。
      </p>
      <p>
        我们希望提供给您的服务是完善的，所以我们会不断改进我们的服务，包括技术。这意味着我们的服务可能会经常推出新功能，可能需要收集新的信息。如果我们收集使用个人信息的目的、方式和范围发生变化时或调整，我们会通过适当的方式通知您。
      </p>
      <h2>二、我们如何使用Cookie、Beacon、SDK等同类技术</h2>
      <p>
        在您使用我们的产品与/或服务时，我们可能会通过数据文件标识您的身份，这些向您设备发送的一个或多个数据文件是唯一的，只能被我们的服务器读取和使用。这些数据文件可能是Cookie/FlashCookie或其他类似的技术。向您发送这类数据文件的目的，是为了简化您的登录步骤、存储您的相关偏好设置、帮助判断您的登录状态和为了保卫您的账号、数据安全等。
      </p>
      <p>
        您可以根据自己的偏好或浏览器、操作系统的设置自行管理或删除这类数据文件。例如，您可以清除计算机上保存的Cookie，您也可以设置浏览器拒绝接受Cookie等。一旦您实施了这个“清除”操作，则在某些情况下您可能会被重复的要求验证身份，或者影响您安全访问我们的产品与/或服务。
      </p>
      <p>
        请您理解，为更好地为您提供服务，您将魔果云课切换到设备后台运行时，我们会持续为您提供后台听课服务。
      </p>
      <p>
        此外，我们还会使用SDK技术收集您的个人信息，详见SDK类目，我们可能不定时的对SDK目录的内容进行更新，您继续使用我们服务即表示认可，详情请参见尾部附件：《接入第三方SDK目录》
      </p>
      <h2>三、我们如何共享、转让、披露您的个人信息</h2>
      <h3>（一）共享您的个人信息</h3>
      <p>
        我们承诺对您的个人信息进行保密。除本政策约定的场景或与您另行订立的其他合约外，我们仅在下列情形中与第三方分享您的必要信息：
      </p>
      <div class="list-wrap">
        <p>1)向您提供我们的产品与/或服务；</p>
        <p>2)已经得到了您明确的同意或授权；</p>
        <p>
          3)我们可能会将您的个人信息与我们的关联公司共享。但我们只会共享必要的个人信息，且受本政策中所声明目的的约束。我们的关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们的合作伙伴包括商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们提供基础设施技术服务、数据处理。我们共享这些信息的目的是可以实现我们产品与/或服务的核心业务功能。
        </p>
        <p>
          <b
            >我们向我们的合作伙伴共享您的个人信息的情形逐项列举，详情查看尾部附件《接入第三方SDK目录》。
          </b>
        </p>
        <p>4)应国家机关、有权部门的指令或行政、司法要求所必须提供时；</p>
        <p>5)应您的要求为您处理与他人的纠纷或者争议时；</p>
        <p>6)实现“我们如何使用您个人信息”部分所述的目的；</p>
        <p>
          7)如果您参与抽奖、竞赛或类似的营销运营活动，我们会将您提供的信息用于管理此类活动。若该活动是与第三方联合举办的，我们可能与其分享活动过程中产生的、为完成活动所必要的个人信息，例如中奖用户名单、中奖用户联系方式等，以便第三方为您颁发奖品或提供产品/服务；
        </p>
        <p>
          8)为遵守法律法规和行业习惯，在我们计划于与其他公司合并或其他资本市场活动时，以及其他场景下我们需要接受来自其他主体的尽职调查时，我们可能会将您的信息提供给相关的主体；
        </p>
        <p>
          9)在使用我们产品与/或服务时，如果您与我们的其他用户产生了基于我们产品与/或服务而进行的交易，为了维护交易安全或确认交易，您与您的交易对手可能会在交易过程中或者交易完成后看到对方的部分信息或经过脱敏处理后的部分信息；
        </p>
        <p>
          10)您主动通过我们的产品与/或服务，与我们的其他用户、机构或合作伙伴订立合约时，我们将提供您必要的个人信息（例如真实姓名、身份证号、联系方式等）给订立合约时的所有关联人员；
        </p>
        <p>
          11)在法律法规允许的范围内，为了维护我们、我们关联公司或合作伙伴、您与其他用户或社会公众利益、财产或安全免遭损失而有必要提供时。
        </p>
      </div>
      <p>
        根据法律规定，共享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您同意。
      </p>
      <h3>（二）转让您的个人信息</h3>
      <p>
        我们不会将您的个人信息转让给除我们、我们关联公司及合作伙伴/机构以外的其他公司、组织或个人，但以下情况除外：
      </p>
      <div class="list-wrap">
        <p>1）已获得您的明确同意和授权；</p>
        <p>
          2）根据可适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行转让；
        </p>
        <p>
          3）如我们或我们的关联方涉及合并、分立、收购、资产或业务转让或类似的交易，您的个人信息可能作为此类交易的一部分而被转让，我们将向您告知个人信息转让的情况，并通过协议的方式要求受让方继续履行本隐私政策中我们所承担的责任和义务，同时，我们将确保该等信息在转移时的机密性，您同意对此予以认可和理解。
        </p>
      </div>
      <h3>（三）披露您的个人信息</h3>
      <p>我们将会在以下情况下披露您的个人信息：</p>
      <div class="list-wrap">
        <p>1）根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
        <p>
          2）符合我们、我们的关联方、合作方与您签署的相关协议或其他法律法规约定所披露；
        </p>
        <p>
          3）根据法律、法规的要求、强制性的行政执法、司法或监管机构要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
        </p>
      </div>
      <h3>（四）共享、转让、披露个人信息授权同意的例外</h3>
      <p>
        根据相关法律法规的规定，在以下情形下，我们可以在不征得您的授权同意的情况下共享、转让、披露您的个人信息：
      </p>
      <div class="list-wrap">
        <p>1）与我们履行法律法规法规规定的义务相关的</p>
        <p>2）与国家安全、国防安全有关的</p>
        <p>3）与公共安全、公共卫生、重大公共利益有关的</p>
        <p>4）与犯罪侦查、起诉、审判和判决执行等有关的</p>
        <p>
          5)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的
        </p>
        <p>6）您自行向社会公众公开的个人信息</p>
        <p>
          7）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道
        </p>
        <p>8）根据法律法规的规定及有权机关等行业组织的要求及其他合法合规情形</p>
      </div>
      <p>
        根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
      </p>
      <h2>四、我们如何存储和保护您的个人信息</h2>
      <p>
        （一）除非另有约定或法律另有规定，我们在中华人民共和国境内收集和产生的个人信息将储存在中华人民共和国境内。对在中华人民共和国境外收集和产生的个人信息，我们将按照中华人民共和国认可效力的法律、法规、国际规则或国际惯例予以存储。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：
      </p>
      <div class="list-wrap">
        <p>
          1）完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉
        </p>
        <p>2）保证我们为您提供服务的安全和质量</p>
        <p>3）您是否同意更长的留存期间</p>
        <p>4）是否存在关于保留期限的其他特别约定或法律法规规定。</p>
      </div>
      <p>
        在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。
      </p>
      <p>
        （二）我们向您承诺，我们将使用以下措施，使得信息安全保护达到合理的水平：
      </p>

      <p><b>1)技术措施 </b></p>
      <p>
        我们会采用符合行业标准的安全保护措施，包括对网络服务采用传输层安全协议等加密技术，确保用户数据在传输过程中的安全，并通过隔离技术对存储的数据进行隔离。
      </p>
      <p>
        在部分使用您个人信息的场景中（例如个人信息展示、个人信息确认等），我们会采用包括内容替换、单向哈希在内等多种数据脱敏技术增强您的个人信息在使用中的安全性。
      </p>
      <p>
        我们亦采用了严格的访问权限控制、多因子身份认证等技术保护您个人信息，避免数据被违规获取。
      </p>
      <p><b>2)访问规范 </b></p>
      <p>
        我们建立了信息安全制度、数据分级管理规范、安全/开发规范等制度规范来管理您个人信息的存储、访问和使用。
      </p>
      <p>
        我们对信息接触者签署了保密协议，并应用了访问日志、行为监控和专门的审计措施来对数据进行全面的管控。
      </p>
      <p><b>3)其他保护方式 </b></p>
      <p>
        在员工安全意识培养上，我们会定期举办安全、隐私相关的宣讲培训、考试。
      </p>
      <p>
        我们以最小授权为原则，我们也只允许必要知晓这些信息的我们及我们关联公司的员工、合作伙伴访问、接触个人信息，并适用上文提到的所有技术措施和规范限制。我们要求相关的人员必须履行相关的保密义务，如果未能履行这些义务，则其可能会被解雇或中止与我们的合作关系，直至追究其法律责任。
      </p>
      <p>
        （三）互联网环境不是绝对安全的环境，您通过各种交流方式与其他用户的交流无法确定是否已经得到了适当的保护。我们建议您在使用其他交流工具时，注意保护个人信息安全，不要泄露个人信息或您的账户私密信息，同时在相关工具上启用复杂的密码。
      </p>
      <p>
        （四）请您理解，由于技术水平限制及可能存在的各种恶意手段，有可能因为我们可控范围外的因素而出现问题。我们强烈建议您采取积极措施保护您个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等您的个人信息透露给他人。您在使用服务时，我们会通过账号、密码及其他身份要素来识别其身份。根据法律法规的要求，在不幸发生个人信息安全事件后，我们将按照法律法规的要求并最迟不迟于30个工作日内向您告知：安全事件的基本情况和可能的影响；我们已经采取或即将采取的处置措施；您可以自主防范和降低风险的建议；对您的补救措施等。我们同时会及时将事件相关情况以不限于邮件、信函、电话、推送通知或站内消息等方式告知您。如果难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告，并按照监管部门的要求，主动上报个人信息安全事件的处置状况。
      </p>
      <p>
        （五）我们会根据法律法规要求的期限保存您的交易信息等个人信息，当您提出删除您的个人信息、注销帐户或者在超过前述保存期限后，我们将进行删除或进行匿名化等脱敏处理。
      </p>
      <p>
        （六）我们不对有可能进入第三方网站的隐私政策的合法性负责，您应检查第三方网站的隐私政策并确定是否接受。
      </p>
      <h2>五、您如何保护和管理您的个人信息</h2>
      <p>
        （一）我们将尽力保护您对于您个人信息的访问、更新、更正您个人信息的权利，除法律法规规定的情形外，您有权随时行使这个权利。您可以通过以下方式自行进行：登录魔果云课，通过“我的”-“个人资料”访问、更新、更正您个人信息。
      </p>
      <p>（二）当出现以下任一情形时，您可以向我们提出删除个人信息的请求：</p>
      <div class="list-wrap">
        <p>1)如果我们处理个人信息的行为违反了法律法规；</p>
        <p>2)如果我们处理个人信息的行为违反了和您的约定；</p>
        <p>3)如果我们终止服务及运营。</p>
        <p>4）如果您主动注销了账户。</p>
      </div>
      <p>（三）您可以通过以下方式撤回您的同意授权：</p>
      <p>
        您可以通过以下方式撤回您对我们收集、使用个人信息的同意授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。请您理解，当您撤回授权后，我们无法继续为您提供撤回授权所对应服务。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </p>
      <div class="list-wrap">
        <p>1）关于授权的撤回同意：</p>
        <p>
          针对安卓系统设备，您可通过手机的“设置”-“应用”-“魔果云课”中的权限设置来关闭授权；
        </p>
        <p>
          针对iOS系统设备，您可通过手机的“设置”-“魔果云课”中的权限设置来关闭授权。
        </p>
        <p>
          2）关于隐私信息的撤回同意：您可通过“魔果云课”-“我的”-“设置-“注销账号”来撤回。
        </p>
      </div>
      <p>（四）您可以通过以下方式申请注销您的账户：</p>
      <div class="list-wrap">
        <p>
          1）登录手机端魔果云课，通过“我的”-“设置-“注销账号”提交注销申请，注销申请提交后，你的账号将被冻结，无法登录；
        </p>
        <p>
          2）在提交注销申请前，请先点击并仔细阅读《自愿申请注销魔果云课账号的声明》并选择是否勾选，在您勾选后点击“坚持注销账号”按钮，即注销成功且不可逆转，请谨慎操作！一旦通过我们的审核，我们与您所持有的魔果云课账号有关的所有信息都将被删除，包括但不限于用户信息、订单信息、交易信息、课程信息、活动信息、财务资金以及其他虚拟权益等。同时，一旦您的账户注销成功，且我们将终止您魔果云课账号相关的一切服务，我们与您的权利义务关系自成功注销账户之日终止，因此请您谨慎操作。
        </p>
      </div>
      <p>（五）您有权获取您的个人信息副本</p>
      <p>
        如您需要获取我们收集的您的个人信息副本，您可通过本隐私政策中第十条中“如何联系我们”提到的联系方式，联系我们获取您的个人信息副本，在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。
      </p>
      <p>（六）约束信息系统自动决策</p>
      <p>
        在某些业务功能中，我们可能仅依据信息系统、算法的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。
      </p>
      <p>
        （七）对于您向我们提出的上述请求，我们将在必要的身份验证通过后进行处理，我们可能会先要您验证自己的身份，然后再处理请求，我们将在15个工作日内做出答复。对于您合理的请求，我们原则上不收取费用。然而，按照有关法律法规及国家标准，在以下情形中，我们无法对您的请求进行响应：
      </p>
      <div class="list-wrap">
        <p>1)与国家安全、国防安全有关的；</p>
        <p>2)与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>3)与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>4)有充分证据证明您存在主观恶意或滥用权利的；</p>
        <p>5)响应您的请求将导致其他个人、组织的合法权益受到严重损害的；</p>
        <p>6)应国家有权机关的要求的；</p>
        <p>7)法律法规规定的其他情形。</p>
        <p>
          8）如果您认为我们处理您的个人信息的行为损害您的隐私，您可以根据通过本政策“第十条如何联系我们”向客服发起书面投诉，我们会在接到投诉后15个工作日内答复。
        </p>
        <p>
          9）如果您不对我们的前述回复不满意，您还可以通过向正规方式和渠道争取解决争议。
        </p>
      </div>
      <h2>六、本政策的适用和修订</h2>
      <p>
        本隐私政策是我们统一使用的隐私条款，我们所有产品与/或服务均适用本政策。在我们部分的其他产品与/或服务中，可能会有其产品与/或服务特定的隐私政策，这些特定的隐私政策将更具体地说明我们在其中如何使用您的信息，且这些特定的隐私政策是本政策不可分割的一部分；如果这些产品与/或服务中特定的隐私政策与本政策有不一致之处，以该特定的产品与/或服务的隐私政策为准。
      </p>
      <p>
        随着我们业务的发展，我们的产品与/或服务会发生升级和调整，我们可能会依据功能调整、使用规则变更、适用法律法规变更或监管要求变更等的情形适时对本政策进行修订。
      </p>
      <p>
        未经您明确同意，我们不会削减您依据当前生效的本政策所应享受的权利。一旦我们对本政策进行了修订，我们会通过我们的产品与/或服务向您提示相关内容的更新，我们会将变更后的政策公布于魔果云课官网、App客户端和小程序中，并以系统内消息方式通知您，同时，也请您关注我们以便及时了解最新的隐私政策。如果您在本政策修订后继续使用我们的产品与/或服务，则表示您已经充分阅读、理解并接受修订后的隐私政策，且愿意接受修订后政策的约束，否则您可能将无法继续使用我们的产品与/或服务。
      </p>
      <h2>七、关于未成年人信息的保护</h2>
      <p>
        我们十分重视未成年人个人信息的保护。如果您是年龄未满18周岁的未成年人，您应当请您的父母或监护人阅读本政策。
      </p>
      <p>
        在征得您父母或监护人明确或书面同意本隐私政策内容前，您应当停止使用我们的产品与/或服务。
      </p>
      <p>
        如您的父母或监护人不同意您按照本政策使用我们的产品与/或服务或向我们提供信息，请您立即终止使用我们的产品与/或服务，并及时通知我们，以便我们采取相应的措施。
      </p>
      <h2>八、术语释义</h2>
      <p>
        （一）为了您的个人信息安全，也为了让您能更清楚明白我们获取的您的个人信息，我们将收集到的您的部分个人信息再次向您进行如下罗列，未罗列的，以本政策约定为准：
      </p>
      <div class="list-wrap">
        <p>
          1)个人基本信息（包括个人姓名、生日、性别、地址、电话号码、电子邮箱）；
        </p>
        <p>2)个人身份信息（身份证有效证件信息）；</p>
        <p>
          3)网络身份标识信息（包括系统账号、IP地址、邮箱地址、前述相关的密码、口令、密保信息等）；
        </p>
        <p>
          4)个人财产信息（交易记录、消费记录、申请信贷记录、银行卡信息，以及资金账户余额、C币、参加的课程虚拟财产信息）；
        </p>
        <p>5)个人上网记录（网站浏览记录、软件使用记录、点击记录）；</p>
        <p>
          6)个人设备信息（包括硬件型号、设备硬件参数、操作系统类型和基本信息、MAC地址、移动设备识别码（IMEI、IDFA、IDFV、OAID、MEID、ICCID、设备SN、AndroidID等移动设备标识别码）、设备序列号和设备传感器信息、SIM卡信息在内的个人常用设备信息）；
        </p>
      </div>
      <p>
        （二）个人敏感信息：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。我们实际具体收集的个人敏感信息以本政策约定为准，且以粗体进行显著标识。
      </p>
      <p>
        （三）设备：是指可用于访问我们的产品与/或服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。
      </p>

      <p>
        （四）IP地址：每台上网的设备都会指定一个编号，称为互联网协议(IP)地址。这些编号通常都是根据地理区域指定的。IP地址通常可用于识别设备连接至互联网时所在的位置。
      </p>

      <p>
        （五）Cookie：Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：WebBeacon、Proxy、嵌入式脚本。
      </p>

      <p>
        （六）帐号：当您注册帐号并向我们提供一些个人信息，您就可以更好的使用我们的服务。当您访问时，系统会利用这些帐号信息对您进行身份验证，以防止未经授权的人员访问您的帐号。
      </p>

      <p>
        （七）信息匿名化：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。
      </p>
      <p>
        （八）去标识化：通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别或者关联个人信息主体的过程。
      </p>

      <p>（九）儿童：不满十四周岁的未成年人。</p>
      <h2>九、法律适用与管辖</h2>
      <p>
        双方在履行本协议的过程中，如发生任何争议，则双方应首先进行友好协商解决；协商不成的，任何一方有权向北京市朝阳区人民法院提起诉讼。
      </p>
      <h2>十、如何联系我们</h2>
      <p>
        当您对本隐私政策内容有任何问题或者建议，请与我们联系，邮箱：service@moguoyunke.com。一般情况下，我们将在收到您的问题、建议之日起15个工作日内予以回复。
      </p>
      <h2 style="margin: 60px 0 30px">附件</h2>
      <h1>接入第三方SDK目录</h1>
      <h3>1.腾讯云-实时互动-教育版</h3>
      <p>类型：工具</p>
      <p>
        收集信息：设备生产商、设备型号、操作系统版本号、网络类型、Wi-Fi状态、IP地址、相机、录音、屏幕分辨率、终端用户的设备型号、操作系统、唯一设备标识符（Android端如AndroidID/OAID，iOS端如iOS14.5之前的IDFA）、连接的WIFI、登录IP地址、接入网络的方式、类型和状态、网络质量数据、操作日志、服务日志信息（如终端用户的操作记录、服务故障信息等信息）等日志信息。
      </p>
      <p>使用目的与场景：互动直播教室服务</p>
      <p>收集方式：SDK本机采集</p>
      <p>公司名称：腾讯云计算（北京）有限责任公司</p>
      <p>
        第三方隐私政策链接地址：https://cloud.tencent.com/document/product/1639/79924
      </p>

      <h3>2. COS V5 Android SDK</h3>
      <p>类型：工具</p>
      <p>收集信息：网络状态、IP地址、系统属性、多媒体文件、AndroidID</p>
      <p>
        使用目的与场景：根据您使用SDK的日志信息分析产品的运行情况，并为您提供更好的产品体验
      </p>
      <p>实现SDK产品功能所需的权限：网络权限</p>
      <p>处理方式：采用SSL协议加密及HTTPS传输加密技术保障安全</p>
      <p>公司名称：腾讯云计算（北京）有限责任公司</p>
      <p>
        第三方SDK隐私政策链接：https://cloud.tencent.com/document/product/436/74059
      </p>
      <p>
        第三方SDK官网链接：https://cloud.tencent.com/document/product/436/12159
      </p>
    </div>
  </div>
</template>
<script>
import { themeMixin } from '@saas/components/src/composables/useTheme';

const logoLight = require('../../assets/images/logo.png');
const logoDark = require('@saas/components/assets/images/logo-white.png');

export default {
  mixins: [themeMixin],
  data() {
    return {};
  },
  computed: {
    brandLogo() {
      return this.isDark ? logoDark : logoLight;
    },
  },
};
</script>
<style scoped src="../../assets/css/zx-agreement.css"></style>

<style scoped>
.header-img {
  filter: none;
}
</style>
